module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "address-group"
  }, [_vm._t("default", [_c('addr')])], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f468196","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Profiler/AddressGroup.vue
// module id = 780
// module chunks = 0